import { EngineResult } from './constants'
import { decision } from './decision'
import { matchesDailyInterval } from './matchesDailyInterval'

// ============================================================
// DAILY RECURRENCE EVALUATOR
// ============================================================

export function evaluateDaily({
    template,
    operationalDate
}) {

    // ------------------------------------------
    // Not started yet
    // ------------------------------------------

    if (
        template.recurrence_start_date &&
        operationalDate < template.recurrence_start_date
    ) {

        return decision({

            generate: false,

            code: EngineResult.NOT_STARTED,

            reason: 'Start date has not been reached'

        })
    }

    // ------------------------------------------
    // Ended
    // ------------------------------------------

    if (
        template.recurrence_end_date &&
        operationalDate > template.recurrence_end_date
    ) {

        return decision({

            generate: false,

            code: EngineResult.EXPIRED,

            reason: 'Template has expired'

        })
    }

    console.log(
        'evaluateDaily operationalDate:',
        operationalDate
    )

    // ------------------------------------------
    // Interval
    // ------------------------------------------

    if (
        !matchesDailyInterval({

            template,

            operationalDate

        })
    ) {

        return decision({

            generate: false,

            code: EngineResult.NOT_READY,

            reason: 'Daily interval not reached'

        })
    }

    // ------------------------------------------
    // Generate today's occurrence
    // ------------------------------------------

    return decision({

        generate: true,

        code: EngineResult.READY,

        reason: 'Daily recurrence',

        dueDate: operationalDate

    })
}